import { ChatFrame } from "../types/chat-frame";

export const chatFrameFallback: ChatFrame = {
  styles: {
    transform: 'translateY(calc(-100% - 11px))',
    position: 'absolute',
    top: 0,
    right: 0,
    bottom: 0,
    height: '65vh',
    width: '400px',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
    borderRadius: '10px',
    filter: 'drop-shadow(0px 0px 30px rgba(0, 0, 0, 0.07))'
  },

  chatFrameHeader: {
    styles: {
    },
  },

  chatFrameBody: {
    styles: {
      flex: '1 1 auto',

      display: "flex",
      flexDirection: 'column'
    }
  },

  chatFrameFooter: {
    styles: {

    }
  },
};